// Allow injecting a Sentry instance for Node.js environments
let sentryInstance = null;
export var Sentry;
(function (Sentry_1) {
    /** Set the Sentry instance (for Node.js apps using @sentry/node) */
    function setInstance(sentry) {
        sentryInstance = sentry;
    }
    Sentry_1.setInstance = setInstance;
    function getSentry() {
        if (sentryInstance)
            return sentryInstance;
        if (typeof window !== "undefined")
            return window.Sentry;
        return null;
    }
    function captureException(error, options = {}) {
        const Sentry = getSentry();
        if (Sentry) {
            Sentry.captureException(error, {
                tags: {
                    ...options.tags,
                    "client.version": "new_restaumatic_client",
                },
                level: options.level,
                extra: options.extra,
            });
        }
    }
    Sentry_1.captureException = captureException;
    function logError(error, options = {}) {
        captureException(error, { ...options, level: "log" });
    }
    Sentry_1.logError = logError;
    // Tag shape must match the higgs/pendolino backends (pendolino
    // config/initializers/sentry.rb) so Sentry issues cross-link by trace_id.
    function setTrace(traceId, spanId) {
        var _a, _b, _c;
        const Sentry = getSentry();
        if (!Sentry)
            return;
        (_a = Sentry.setTag) === null || _a === void 0 ? void 0 : _a.call(Sentry, "trace_id", traceId);
        (_b = Sentry.setTag) === null || _b === void 0 ? void 0 : _b.call(Sentry, "signoz", `https://signoz.manca.ro/trace/${traceId}`);
        (_c = Sentry.setContext) === null || _c === void 0 ? void 0 : _c.call(Sentry, "trace", { trace_id: traceId, span_id: spanId });
    }
    Sentry_1.setTrace = setTrace;
})(Sentry || (Sentry = {}));
